/**
* Virtual Consultation Callout JS
* -----------------------------------------------------------------------------
*
* All the JS for the Virtual Consultation Callout component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'virtual-consultation-callout',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.virtual-consultation-callout' ).each( function() {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 75%',
            scrub: 0.15,
            // markers: true,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'is-loaded' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'is-loaded' ),
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'virtual-consultation-callout', COMPONENT );
} )( app );
